module.exports = __webpack_public_path__ + "static/media/mehndi.8e6f0f01.JPG";